import { useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import PhoneInput from "react-phone-input-2";
import UsersService from "../../../../services/UsersService";
import { Translate } from "../../../Enums/Tranlate";

const AddUserModal = ({ addModal, setAddModal, setShouldUpdate }) => {
	const [formData, setFormData] = useState({
		username: "",
		email: "",
		password: "",
		phone: "",
		age: "",
	});
	const [showPassword, setShowPassword] = useState(false);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth.lang);
	const usersService = new UsersService();

	const submit = (e) => {
		e.preventDefault();

		let data = {
			fullname: formData?.name,
			email: formData?.email,
			password: formData?.password,
			phone: formData?.phone,
			age: formData?.age,
		};

		setLoading(true);
		usersService
			.create(data)
			?.then((res) => {
				if (res?.status === 201) {
					toast.success(res?.data?.message);
					setShouldUpdate((prev) => !prev);
					setAddModal();
				}
				setLoading(false);
			})
			.catch(() => setLoading(false));
	};

	return (
		<Modal
			className={lang === "en" ? "en fade addAdmin" : "ar fade addAdmin"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={() => {
				setAddModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0"
									style={{
										fontWeight: "600",
										color: "#333",
										fontSize: "20px",
									}}>
									{Translate[lang]?.add} {Translate[lang]?.user}
								</p>
								<Button
									variant=""
									className="close"
									style={{
										right: lang === "en" ? "0" : "auto",
										left: lang === "ar" ? "0" : "auto",
									}}
									onClick={() => {
										setAddModal();
									}}>
									<span style={{ fontSize: "22px" }}>&times;</span>
								</Button>
							</div>
						</Col>
						{/* Name */}
						<Col md={12}>
							<label className="text-label">{Translate[lang]?.name}</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.name}
								bsSize="lg"
								name="name"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.name}
								onChange={(e) =>
									setFormData({
										...formData,
										name: e.target.value,
									})
								}
							/>
						</Col>
						{/* Phone */}
						<Col md={12} className="mb-3">
							<label>{Translate[lang]?.phone}</label>
							<PhoneInput
								country={"kw"}
								enableSearch={true}
								value={formData?.phone}
								onChange={(e) => setFormData({ ...formData, phone: e })}
							/>
						</Col>
						{/* Age */}
						<Col md={12}>
							<label>{Translate[lang]?.age}</label>
							<AvField
								type="number"
								placeholder={Translate[lang]?.age}
								bsSize="lg"
								name="age"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.age}
								onChange={(e) =>
									setFormData({
										...formData,
										age: e.target.value,
									})
								}
							/>
						</Col>
						{/* Email */}
						<Col md={12}>
							<label>{Translate[lang]?.email}</label>
							<AvField
								type="email"
								placeholder={Translate[lang]?.email}
								bsSize="lg"
								name="email"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.email}
								onChange={(e) =>
									setFormData({
										...formData,
										email: e.target.value,
									})
								}
							/>
						</Col>
						{/* Password */}
						<Col md={12} className="form-group mb-0 position-relative">
							<label>{Translate[lang]?.password}</label>
							<AvField
								type={showPassword ? "text" : "password"}
								placeholder={Translate[lang]?.password}
								bsSize="lg"
								className="radius-10"
								name="password"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.password}
								onChange={(e) =>
									setFormData({
										...formData,
										password: e.target.value,
									})
								}
							/>
							{showPassword ? (
								<i
									className="la la-eye-slash position-absolute cursor-pointer"
									style={{
										top: "44px",
										right: lang === "en" ? "8%" : "auto",
										left: lang === "ar" ? "8%" : "auto",
									}}
									onClick={() => setShowPassword(false)}></i>
							) : (
								<i
									className="la la-eye position-absolute cursor-pointer"
									style={{
										top: "44px",
										right: lang === "en" ? "8%" : "auto",
										left: lang === "ar" ? "8%" : "auto",
									}}
									onClick={() => setShowPassword(true)}></i>
							)}
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="primary"
						type="submit"
						className="w-100"
						disabled={loading}>
						{Translate[lang]?.add} {Translate[lang]?.user}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default AddUserModal;
